export const resourceHref =
    "https://gitlab.mercator-ocean.fr/pub/edito-infra/edito-tutorials-content";
